import React from 'react';
import {
  getAlertManagerType,
  getAlertsForLevel,
  getCurrentBlockingAlert,
  getAllActivePartnerAlerts,
} from 'extractFromState';
import { connect } from 'react-redux';
import { setAlertManagerType } from 'actions/tools/ToolActions';
import { setCenterPaneExtraInfoPanelActive } from 'actions';
import {
  alertsTypesList,
  alertsTypesMap,
  GUIDE,
  ALWAYS_BLOCK,
  BLOCK_ONCE,
  ESCALATION,
  ESCALATION_PARTNER,
} from 'constants/alerts';
import { getIconForAlert } from 'util/alertUtil';
import { READ, ALL_ALERTS } from 'constants/alerts';
import {
  AlertSection,
  IconAndLabel,
  RelativeWrapper,
  UnreadMarker,
  AlertIconContainer,
  SeeAllButton,
} from './AlertCenterPanel.styles';

const AlertCenterPanel = ({
  alerts,
  setAlertType,
  alertManagerType,
  setExtraInfoPanelActive,
  currentBlockingAlert,
  allActiveAlerts,
}) => {
  const getUnreadCount = (type) => {
    const unreadAlerts = alerts.filter((alert) => {
      // put non-assigned types under GUIDE for backwards compatibility
      if (type === GUIDE) {
        return alert.readStatus !== READ && (alert.type === type || !alert.type);
      } else if (type === ESCALATION || type === ESCALATION_PARTNER) {
        // if its one of the two escalation alert types, count these together
        return alert.readStatus !== READ && (alert.type === ESCALATION || alert.type === ESCALATION_PARTNER);
      }

      return alert.readStatus !== READ && alert.type === type;
    });

    return unreadAlerts.length;
  };

  const getSectionLabel = (alertType) => {
    return alertsTypesMap[alertType] && alertsTypesMap[alertType].label;
  };

  const shouldShowSection = (type) => {
    const totalAlerts = alerts.filter((alert) => {
      // put non-assigned types under GUIDE for backwards compatibility
      return type === GUIDE ? alert.type === type || !alert.type : alert.type === type;
    });

    return totalAlerts.length > 0;
  };

  const contextualAlertsArePresent = () => {
    return alertsTypesList.some((type) => shouldShowSection(type));
  };

  const shouldShowUnread = (type) => {
    return getUnreadCount(type) > 0;
  };

  const blockingAlertsPresent = (alertType, blockType) => {
    if (alertType === GUIDE) {
      return alerts.some((alert) => (alert.type === alertType || !alert.type) && alert.blockType === blockType);
    }

    return alerts.some((alert) => alert.type === alertType && alert.blockType === blockType);
  };

  const getBlockingIcon = (alertType) => {
    if (blockingAlertsPresent(alertType, ALWAYS_BLOCK)) {
      return <img src="/images/block-always-icon.svg" alt="block" />;
    } else if (blockingAlertsPresent(alertType, BLOCK_ONCE)) {
      return <img src="/images/block-once-icon.svg" alt="block" />;
    }

    return null;
  };

  const handleSectionClick = (alertType) => {
    // buttons should deactivated if there is a blocking
    // alert present
    if (currentBlockingAlert) {
      return;
    }

    if (alertManagerType) {
      if (alertManagerType === alertType) {
        return setAlertType(null);
      }
      setExtraInfoPanelActive(false, null, null);

      return setAlertType(alertType);
    }
    setExtraInfoPanelActive(false, null, null);
    setAlertType(alertType);
  };

  return (
    <>
      {contextualAlertsArePresent() && (
        <AlertIconContainer>
          {alertsTypesList.map((alertType, idx) => {
            return shouldShowSection(alertType) ? (
              <RelativeWrapper key={`${alertType}_${idx}`}>
                <AlertSection selected={alertManagerType === alertType} onClick={() => handleSectionClick(alertType)}>
                  <IconAndLabel>
                    <img src={getIconForAlert(alertType)} alt={alertType} />
                    <p>{getSectionLabel(alertType)}</p>
                    {shouldShowUnread(alertType) && <UnreadMarker>{getUnreadCount(alertType)}</UnreadMarker>}
                  </IconAndLabel>
                  {getBlockingIcon(alertType)}
                </AlertSection>
              </RelativeWrapper>
            ) : null;
          })}
        </AlertIconContainer>
      )}
      {!!allActiveAlerts.length && (
        <SeeAllButton onClick={() => handleSectionClick(ALL_ALERTS)} selected={alertManagerType === ALL_ALERTS}>
          SEE ALL ALERTS
        </SeeAllButton>
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  alerts: getAlertsForLevel(state) || {},
  alertManagerType: getAlertManagerType(state),
  currentBlockingAlert: getCurrentBlockingAlert(state),
  allActiveAlerts: getAllActivePartnerAlerts(state),
});

const mapDispatchToProps = (dispatch) => ({
  setAlertType: (type) => dispatch(setAlertManagerType(type)),
  setExtraInfoPanelActive: (value, order, subscription) => {
    dispatch(setCenterPaneExtraInfoPanelActive(value, order, subscription));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(AlertCenterPanel);
